export interface CommentAnalyticsDto {
	availableComments: number;
	sentiment: {
		positive: number;
		negative: number;
		neutral: number;
	};
	type: {
		idea: number;
		praise: number;
		critic: number;
		sensitive: number;
		other: number;
	};
	keywords: Record<string /* id */, { id: string; count: number }>;
}

export enum SentimentRating {
	positive = "positive",
	neutral = "neutral",
	negative = "negative",
}

export enum CommentType {
	idea = "idea",
	praise = "praise",
	critic = "critic",
	sensitive = "sensitive",
	other = "other",
}
